



























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import BIObject from '@/types/taxcard/BIObject';
import TicketSelectPage from '@/views/taxcard/transaction/TicketSelectPage.vue';
import CheckboxField from '@/components/form/CheckboxField.vue';
import TextField from '@/components/form/TextField.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import Validity from '@/app/utils/Validity';
import AppApi from '@/app/api/AppApi';

@Component({ components: { NewTranslation, TextField, CheckboxField, TicketSelectPage } })
export default class TicketSelectOverlay extends Vue {
  @Prop({ type: Object, required: false })
  public transaction!: any | null;

  @Prop(Function)
  public isSelectable!: (x: BIObject) => boolean;

  shareMailOnly: boolean = true;
  invalidMail: boolean = false;
  mailAddress: string = '';

  @Emit()
  public close(): void {}

  public mounted() {
    this.$trackEvent('transaction-overview', 'share', 'entered');
  }

  public select(ticketIds: number[]) {
    if ((this.shareMailOnly || this.mailAddress) && !Validity.isValidEmail(this.mailAddress)) {
      this.invalidMail = true;
      return;
    }

    this.invalidMail = false;
    this.$trackEvent('transaction-overview', 'share', 'confirm');
    if (this.shareMailOnly) {
      this.$emit('select', { ticketIds, mail: this.mailAddress, mailOnly: true });
    } else {
      this.$emit('select', { ticketIds, mail: this.mailAddress, mailOnly: false });
    }
  }

  public get hideCheckbox() {
    const anyWindow = window as any;
    return !AppApi.canShareOnMobile(anyWindow);
  }
}
